import { PartnerListItem } from '../api/queries';

/**
 * Calculates the total number of customers across all partners.
 *
 * @param partners - Array of partners
 * @returns Total customer count across all partners
 */
export const calculateTotalCustomers = (partners: PartnerListItem[]): number => {
  return partners.reduce((sum, partner) => sum + partner.customerCount, 0);
};
